import type { ErrorExportacion } from '@/hooks/useExportacion';
import { WarningCircle } from '@phosphor-icons/react';

/** Aviso visible cuando falla la exportación a Excel/PDF. */
export function AvisoErrorExportacion({
  error,
  onCerrar,
}: {
  error: ErrorExportacion;
  onCerrar?: () => void;
}) {
  return (
    <div
      role="alert"
      className="rounded-md border border-red-300 bg-red-50 p-3 text-sm text-red-900"
    >
      <div className="flex items-start gap-2">
        <WarningCircle className="mt-0.5 h-4 w-4 shrink-0 text-red-700" weight="fill" />
        <div className="flex-1">
          {error.tipo === 'version' ? (
            <>
              <strong>No se pudo exportar: la página quedó desactualizada.</strong> La aplicación se
              actualizó mientras la tenías abierta y ya no encuentra los módulos de exportación.
              Recargá la página (<kbd>Ctrl</kbd> + <kbd>F5</kbd>) y volvé a exportar.
            </>
          ) : (
            <>
              <strong>No se pudo generar el archivo.</strong> Si el problema sigue, avisá con este
              detalle: <span className="font-mono text-xs">{error.detalle}</span>
            </>
          )}
          <div className="mt-2 flex items-center gap-3 text-xs">
            {error.tipo === 'version' && (
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="rounded border border-red-700 bg-white px-2 py-1 font-medium text-red-800 hover:bg-red-100"
              >
                Recargar ahora
              </button>
            )}
            {onCerrar && (
              <button type="button" onClick={onCerrar} className="text-red-800 underline">
                Cerrar
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
